import { RootState } from 'editor/src/store/index';

const getSessionImages = (state: RootState) =>
  state.gallery.images.filter((image) => state.gallery.sessionImages.includes(image.id));

export default getSessionImages;
